import type { PriceAlerts } from '../../types/PriceAlerts';

export const priceAlertsATFeatureConfig: PriceAlerts = {
    showNotificationsSettings: true,
};
